import type { EventDetailType } from './types'

export const JOURNEY_NAVIGATION_EVENT = 'JourneyNavigationEvent'
export const JOURNEY_LOADING_EVENT = 'JourneyLoadingEvent'
export const JOURNEY_EXIT_EVENT = 'JourneyExitEvent'

export function on(
  eventType: string,
  listener: EventListenerOrEventListenerObject
) {
  window.addEventListener(eventType, listener)
}

export function off(
  eventType: string,
  listener: EventListenerOrEventListenerObject
) {
  window.removeEventListener(eventType, listener)
}

export function trigger(eventType: string, data: unknown) {
  const event = new CustomEvent(eventType, { detail: data })

  window.dispatchEvent(event)
}

export const dispatchLoadingEvent = (isLoading: boolean) => {
  const event = new CustomEvent<EventDetailType>(JOURNEY_LOADING_EVENT, {
    detail: {
      payload: {
        value: isLoading
      }
    }
  })

  document.dispatchEvent(event)
}

/**
 * TODO: should live on the Journey App instead
 */
export const dispatchExitEvent = () => {
  const event = new CustomEvent<EventDetailType>(JOURNEY_EXIT_EVENT)

  document.dispatchEvent(event)
}

/**
 * Convenience method for sending CustomEvents through `window.postMessage`
 * while enforcing type safety
 */
export const postMessage = <T>(
  /** The details of the event you're sending */
  event: T,
  /** Window reference */
  windowRef?: Window | null,
  /** Additional options */
  options?: WindowPostMessageOptions
) => {
  ;(windowRef ?? window).postMessage(event, options)
}
